// import Wallpaper from "../../assets/wallpaper/girl_standing.png";
import Wallpaper from "../../assets/photos/10.jpg";
import WallpaperMobile from "../../assets/photos/10-full.jpg";
import Facebook from "../../assets/socials/facebook.png";
import YouTube from "../../assets/socials/youtube.png";
import Instagram from "../../assets/socials/instagram.png";
// import Photo from "../../assets/photos/1.png";
import Photo from "../../assets/photos/11-3.jpg";
import PhotoMobile from "../../assets/photos/12.jpg";
import Photo2 from "../../assets/photos/2.png";
import Class from "../../assets/photos/25.png";
// import Class from "../../assets/photos/3.png";
import Lib from "../../assets/photos/22.png";
// import Lib from "../../assets/photos/5.png";
import Goose from "../../assets/photos/6.png";
import Online from "../../assets/photos/20.png";
// import Online from "../../assets/photos/4.jpg";
import Prices from "../../assets/photos/13.jpg";
import PricesMobile from "../../assets/photos/13-mobile.jpg";
import "../../styles/circle.css";
import { useAppContext } from "../../context/AppContext";
import { ButtonsTrans, HeaderTrans, LandingTrans, ToasterTrans } from "../../utils/translations";
import '../../styles/circle.css';
import { trackPixelEvent } from "../../utils/pixel";
import ReviewsSection from "../reviews";
import ContactForm from "../ContactForm";
import SetmoreBooking from "../SetmoreBooking";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/logo.png";
import LoginButton from "../LoginButton";
import LanguageToggler from "../LanguageToggler";
import CountryToggler from "../CountryToggler";

export default function LandingPage() {
  const { language, setToaster, isMobile } = useAppContext();
  const learnMoreRef = useRef(null);
  const aboutPracticeRef = useRef(null);
  const classesRef = useRef(null);
  const pricesRef = useRef(null);
  const reviewsRef = useRef(null);
  const contactsRef = useRef(null);
  // const aboutPracticeRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToSection = (ref) => {
    ref?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const isIOS = () => {
    if (typeof navigator !== "undefined") {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    return false;
  };

  const isIosDevice = isIOS();

  const currentPath = location.pathname;

  return (
    <main className="flex min-h-screen flex-col items-center justify-between scroll-smooth ">
      {/* Header */}
      <div className={`sticky shadow-md hidden lg:flex justify-between align-middle items-center px-20 w-screen z-50 text-sm font-medium top-0 bg-white h-10 border-b-[1px] ${(currentPath === "/constructor" || currentPath === "/shop" || currentPath === "/about") && "border-brown"}
`}>
        <a
          href="/landing"
          className="flex items-center gap-2 hover:pointer"
        >
          <img alt="logo" src={Logo} className="w-10 pb-1" />
          <span className="text-pink">
            {HeaderTrans[language].onceUp}{" "}
            <span className="text-black">
              {HeaderTrans[language].onMat}
            </span>
          </span>
        </a>
        <div className="flex justify-between gap-5">
          <span onClick={() => { trackPixelEvent("NavigateToSeeMoreLandingPage"); scrollToSection(learnMoreRef) }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].aboutUs}</span>
          <span onClick={() => { trackPixelEvent("NavigateToSeePracticeLandingPage"); scrollToSection(aboutPracticeRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].aboutPractice}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(classesRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].classes}</span>
          <span onClick={() => { trackPixelEvent("NavigateToReviewsLandingPage"); scrollToSection(reviewsRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].reviews}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(pricesRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].prices}</span>
          <span onClick={() => { trackPixelEvent("NavigateToContactsLandingPage"); scrollToSection(contactsRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].contacts}</span>
        </div>
        <div className="flex gap-5">
          <LoginButton />
          <LanguageToggler />
          <CountryToggler />
        </div>
      </div>
      {/* mobile */}
      <div className="sticky z-50 lg:hidden align-middle text-sm font-medium top-0 bg-white w-screen pt-1 flex">
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-2xl text-black mb-1 pl-4">
          ☰
        </button>
        <a
          href="/landing"
          className="flex items-center w-fit m-auto gap-2 hover:pointer"
        >
          <img alt="logo" src={Logo} className="w-9 pb-1" />
          <span className="text-pink">
            {HeaderTrans[language].onceUp}{" "}
            <span className="text-black">
              {HeaderTrans[language].onMat}
            </span>
          </span>
        </a>
        <div className="flex items-center gap-2 w-fit m-auto">
          <LanguageToggler />
          <LoginButton />
        </div>
      </div>
      {isMenuOpen && (
        <div className="fixed top-9 left-0 w-full bg-white z-40 flex flex-col items-center text-sm text-black shadow-md">
          <span onClick={() => { trackPixelEvent("NavigateToSeeMoreLandingPage"); scrollToSection(learnMoreRef); setIsMenuOpen(false) }} className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].aboutUs}</span>
          <span onClick={() => { trackPixelEvent("NavigateToSeePracticeLandingPage"); scrollToSection(aboutPracticeRef); setIsMenuOpen(false) }} className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].aboutPractice}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(classesRef); setIsMenuOpen(false)}} className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].classes}</span>
          <span onClick={() => { trackPixelEvent("NavigateToReviewsLandingPage"); scrollToSection(reviewsRef);setIsMenuOpen(false) }} className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].reviews}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(pricesRef); setIsMenuOpen(false)}} className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].prices}</span>
          <span onClick={() => { trackPixelEvent("NavigateToContactsLandingPage"); scrollToSection(contactsRef); setIsMenuOpen(false)}} className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].contacts}</span>
          <CountryToggler />
        </div>
      )}

      {/* Main screen */}
      <section>
        <div className="lg:grid lg:grid-cols-2 hidden text-left">
          <div className="lg:col-span-1 hidden lg:block">
            <div className="circle small absolute top-16 -left-28 z-10 hidden lg:block"></div>
            <div className="text-brown text-8xl absolute z-20 bg-lightBeige rounded top-32 lg:left-20 left-4 pt-5 w-2/5">
              {LandingTrans[language].once}
              <br />
              {LandingTrans[language].uponamat ? <div>
                {LandingTrans[language].uponamat} <br />
              </div> : ""}

              <h2 className="text-black mt-7 ml-24 text-lg pb-8">
                {LandingTrans[language].description}
              </h2>
              <div onClick={() => { trackPixelEvent("NavigateToSeeMoreLandingPage"); scrollToSection(learnMoreRef) }} className="absolute bg-black rounded-3xl text-white text-base p-3 left-60 -bottom-20 z-20 border-lightBeige  border-8 hover:bg-beige hover:pointer">
                {LandingTrans[language].learnMore}
              </div>
            </div>
          </div>
          <div className="col-span-1 relative ">
            <div className="h-screen overflow-hidden">
              <img
                alt="girl standing on a mat"
                src={isMobile ? WallpaperMobile : Wallpaper}
                className="w-full"
              />
            </div>
            <div className="flex gap-3 absolute bottom-3 lg:-left-56">
              <a onClick={() => { trackPixelEvent("NavigateToFacebook") }} target="_blank" href="https://www.facebook.com/theanyajoy"><img
                className="w-8 h-8 hover:pointer"
                alt="facebook"
                src={Facebook}
              /></a>
              <a href="https://www.youtube.com/@once-up-on-a-mat"
                onClick={() => trackPixelEvent("NavigateToYoutube")}
                target="_blank"><img
                  className="w-8 h-8 hover:pointer"
                  alt="YouTube"
                  src={YouTube}
                /></a>
              <a onClick={() => trackPixelEvent("NavigateToInstagram")} href={language === "russian" ? "https://www.instagram.com/joykayoga/" : "https://www.instagram.com/once.up.on.a.mat"} target="_blank">
                <img
                  className="w-8 h-8 hover:pointer"
                  alt="Instagram"
                  src={Instagram}
                />
              </a>
            </div>
          </div>
        </div>

        <div className="lg:hidden relative h-screen w-screen overflow-hidden">
          <img
            alt="girl standing on a mat"
            src={isMobile ? WallpaperMobile : Wallpaper}
            className="block absolute inset-0 h-full w-full object-cover object-bottom top-auto bottom-0 inset-x-0"
          />
          <div className="absolute text-2xl m-auto top-16 inset-0 text-center w-9/12">
            <div className="text-brown text-4xl bg-lightBeige rounded-lg px-2 pb-2 w-fit m-auto">
              {LandingTrans[language].once} {LandingTrans[language].uponamat}
            </div>
            <h2 className="text-black rounded-lg mt-7 text-xs bg-lightBeige m-auto py-1 px-2 text-center w-fit">
              {LandingTrans[language].description}
            </h2>
            <a href="/library" onClick={() => trackPixelEvent("NavigateToLibrary")} className="absolute bg-black w-fit right-20 text-center rounded-3xl mt-20 text-white text-xs p-2 hover:bg-beige">
              {ButtonsTrans[language].learnMore}
            </a>
          </div>
          <div className="flex justify-between items-center absolute bottom-8 w-full px-4">
            <div className="flex gap-3">
              <a target="_blank" onClick={() => trackPixelEvent("NavigateToFacebook")} href="https://www.facebook.com/theanyajoy"><img
                className="w-8 h-8 hover:pointer"
                alt="facebook"
                src={Facebook}
              /></a>
              <a href="https://www.youtube.com/@once-up-on-a-mat"
                onClick={() => trackPixelEvent("NavigateToYoutube")}
                target="_blank"><img
                  className="w-8 h-8 hover:pointer"
                  alt="YouTube"
                  src={YouTube}
                /></a>
              <a onClick={() => trackPixelEvent("NavigateToInstagram")} href={language === "russian" ? "https://www.instagram.com/joykayoga/" : "https://www.instagram.com/once.up.on.a.mat"} target="_blank">
                <img
                  className="w-8 h-8 hover:pointer"
                  alt="Instagram"
                  src={Instagram}
                />
              </a>
            </div>
            {/* <a href="/library" className="bg-black rounded-3xl text-white text-xs p-2 z-20 hover:bg-beige">
            {ButtonsTrans[language].exploreMore}
          </a> */}
          </div>
        </div>
      </section>

      {/* About Me */}
      <section
        ref={learnMoreRef}
        className={`bg-beige pb-40 md:pt-5 grid grid-cols-1 md:grid-cols-2 items-center ${isIosDevice ? 'bg-scroll' : 'bg-fixed'} md:bg-scroll bg-[center_right_43%] bg-no-repeat bg-cover`}
        style={{ backgroundImage: `url(${isMobile ? PhotoMobile : Photo})` }}
      >
        <div className="md:mt-3 mb-10 md:px-10 mx-auto text-center md:text-left bg-white/70  hover:bg-white transition-colors duration-300 ease-in-out p-8 md:rounded-xl">
          <h2 className="text-2xl md:text-3xl font-semibold mb-6">{LandingTrans[language].hiFriends}</h2>
          <div className="text-left">
            <p className="text-lg mb-4">
              {LandingTrans[language].myNameIs}
            </p>
            <p className="text-lg mb-4">
              {LandingTrans[language].yogaHelped}
            </p>
            <p className="text-lg">
              {LandingTrans[language].iBelieve}
            </p>
          </div>
        </div>
      </section>

      {/* About and For whom */}
      <section id="about" ref={aboutPracticeRef} className="bg-white py-10 px-6 w-full">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">

          {/* Левая часть - Описание практики */}
          <div className="text-left space-y-4">
            <div>
              <h2 className="text-2xl md:text-4xl font-bold mb-6 flex items-center gap-3"><span className="text-5xl">💡</span>{LandingTrans[language].whatIsThisPractice}</h2>
              <p className="text-lg leading-relaxed">{LandingTrans[language].practiceDescription}</p>
            </div>

            <div>
              <ul className="list-disc list-inside space-y-2 text-lg">
                <strong>{LandingTrans[language].duration}:</strong> {LandingTrans[language].notScary}
                <ul className="list-disc list-inside ml-6 mt-2 space-y-2 text-base">
                  <li>{LandingTrans[language].warmup}</li>
                  <li>{LandingTrans[language].mainBlock}</li>
                  <li>{LandingTrans[language].shavasana}</li>
                </ul>
              </ul>
            </div>
          </div>

          {/* Правая часть - Кому подходит */}
          <div className="bg-orange-50 p-8 rounded-2xl shadow-md text-left space-y-6">
            <h3 className="text-2xl font-semibold mb-4">{LandingTrans[language].whoItFits}</h3>

            <div className="space-y-4 text-lg">
              <p>
                <strong>{LandingTrans[language].newbies}</strong> {LandingTrans[language].regardless}<a href="tel:[+972559116975]" className="text-black hover:text-pink">+972 55 911 69 75</a>.
              </p>

              <p>
                <strong>{LandingTrans[language].pros}</strong>{LandingTrans[language].forWhom}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Class Formats */}
      <section ref={classesRef} className="bg-beige py-16 px-6 w-full">
        <h2 className="text-2xl md:text-4xl font-semibold mb-6 text-center">📍 {LandingTrans[language].formats}</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto text-center">
          {[
            {
              title: LandingTrans[language].liveLessons,
              description: LandingTrans[language].liveLessonsDescription,
              extra: LandingTrans[language].liveLessonsExtra,
              img: Class,
              button: LandingTrans[language].liveLessonsButton,
              link: "https://onceuponamat-com.setmore.com/classes/16e5565a-10cc-4c88-841b-308dbe7fc966?step=time-slot&products=16e5565a-10cc-4c88-841b-308dbe7fc966&type=class&staff=039ffe7d-4637-4d72-800a-263a2c2429e5&staffSelected=false"
            },
            {
              title: LandingTrans[language].library,
              description: LandingTrans[language].libraryDescription,
              extra: LandingTrans[language].libraryExtra,
              img: Lib,
              button: LandingTrans[language].libraryButton,
              link: "/library",
            },
            {
              title: LandingTrans[language].club,
              description: LandingTrans[language].clubDescription,
              extra: LandingTrans[language].clubExtra,
              img: Online,
              button: LandingTrans[language].clubButton,
              link: "/onlineClub",
            },

            {
              title: LandingTrans[language].park,
              description: LandingTrans[language].parkDescription,
              extra: LandingTrans[language].parkExtra,
              img: Goose,
              button: LandingTrans[language].parkButton,
              link: "https://onceuponamat-com.setmore.com/classes/1f65a668-6ae9-4746-8c1f-f25fa490c349"
            },
            // {
            //   title: "Индивидуальные сессии",
            //   description: "Персональные занятия для глубокой работы с телом.",
            //   extra: "Полная адаптация практики под вас и ваши цели.",
            //   img: Photo,
            //   button: "Записаться",
            // },
          ].map((item, idx) => (
            <div
              key={idx}
              className="relative group w-full h-80 [perspective:1000px] mx-auto"
            >
              <div className="relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">

                {/* Front Side */}
                <div className="absolute inset-0 bg-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 [backface-visibility:hidden]">
                  <img src={item.img} alt={item.title} className="rounded-full w-24 h-24 object-cover mb-4" />
                  <h3 className="text-xl md:text-2xl font-semibold mb-2">{item.title}</h3>
                  <p className="text-sm mb-4">{item.description}</p>

                  {/* Subtle mobile-only pointer in top-right */}
                  <div className="absolute bottom-4 right-5 text-xs text-black opacity-80 md:hidden pointer-events-none select-none">
                    ⤷
                  </div>
                </div>

                {/* Back Side */}
                <div className="absolute inset-0 bg-brown text-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 [transform:rotateY(180deg)] [backface-visibility:hidden]">
                  <h3 className="text-xl font-semibold mb-4 text-white">{item.title}</h3>
                  <p className="text-sm text-white">{item.extra}</p>
                  {item.link && language === "russian" ? <a href={item.link} className="border border-darkBrown px-4 py-2 mt-5 rounded-full hover:bg-beige hover:text-black transition text-sm">
                    {item.button}
                  </a> : <button className="border border-darkBrown px-4 py-2 mt-5 rounded-full hover:bg-beige hover:text-black transition text-sm" onClick={() => {
                    setToaster({
                      message: ToasterTrans[language].comingSoon,
                      type: "info",
                      show: true,
                    });
                  }}>{item.button}</button>}
                </div>

              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Отзывы */}
      <section ref={reviewsRef} className="w-full">
        <ReviewsSection />
      </section>

      {/* Prices */}
      {/* <div className="lg:hidden relative h-screen w-screen overflow-hidden">
          <img
            alt="girl standing on a mat"
            src={isMobile ? WallpaperMobile : Wallpaper}
            className="block absolute inset-0 h-full w-full object-cover object-bottom top-auto bottom-0 inset-x-0"
          /> */}
      <section
        ref={pricesRef}
        className={`pb-20 pt-10 px-10 md:px-32 relative items-center ${isIosDevice ? 'bg-scroll' : 'bg-fixed'} md:bg-scroll md:bg-no-repeat bg-cover`}
        >
        <img
          alt="girl standing on a mat"
          src={isMobile ? PricesMobile : Prices}
          className="block absolute inset-0 h-full w-full object-cover object-bottom top-auto bottom-0 inset-x-0"
        />
        <h2 className="relative text-2xl md:text-4xl font-semibold mb-10 text-center">
          📦 {LandingTrans[language].prices}
        </h2>
        <div className="mx-auto grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { title: LandingTrans[language].club, exert: LandingTrans[language].clubDes, price: "100₪" },
            { title: LandingTrans[language].trial, exert: LandingTrans[language].trialDes, price: "50₪" },
            { title: LandingTrans[language].one, exert: LandingTrans[language].oneDes, price: "70₪" },
            { title: LandingTrans[language].four, exert: LandingTrans[language].fourDes, price: "250₪" },
            { title: LandingTrans[language].eight, exert: LandingTrans[language].eightDes, price: "350₪" },
            { title: LandingTrans[language].limitless, exert: LandingTrans[language].limitlessDes, price: "400₪" },
          ].map((card, idx) => (
            <div
              key={idx}
              className="bg-white/70 py-10 hover:bg-white rounded-2xl p-6 text-center transition-all duration-500 ease-in-out transform hover:-translate-y-2 hover:shadow-2xl"
            >
              <p className="font-bold text-lg md:text-xl mb-5 text-darkBrown">{card.title}</p>
              <h2 className="text-2xl md:text-3xl font-semibold text-darkBrown mb-5 text-center">{card.price}</h2>
              <p className="text-base md:text-lg text-darkBrown">{card.exert}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Map and contacts */}
      <section ref={contactsRef} className="bg-и py-16 px-6 w-full">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">

          {/* Левая колонка — Квадратная карта */}
          <div className="w-full aspect-square rounded-2xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3380.6261411834885!2d34.82204497506704!3d32.079359119313345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d4b96ba065fbd%3A0x47802fb082d428ed!2sYoga%20Studio%20-%20Once%20Up%20On%20a%20Mat!5e0!3m2!1sen!2sil!4v1745886643692!5m2!1sen!2sil"
              width="100%"
              height="100%"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Карта студии"
            ></iframe>
          </div>

          {/* Правая колонка — Контакты + Форма */}
          <div className="flex flex-col justify-around h-full space-y-0">

            {/* Контакты */}
            <div className="text-center md:text-left space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold md:text-left text-center">📞 {LandingTrans[language].contacts}</h2>
              <p className="text-base text-darkBrown/80">
                {LandingTrans[language].yogaStudio}<br />
                {LandingTrans[language].address}
              </p>
              <p className="text-base text-darkBrown/80">
                📲 WhatsApp / Telegram:{" "}
                <a href="https://wa.me/972559116975" target="blank" className="text-pink-600 hover:underline">
                  +972 55 911 69 75
                </a>
              </p>
              {/* Booking Button */}
              {language === "russian" && <div className="w-fit md:m-0 m-auto">
                <SetmoreBooking
                  buttonTextComponent={
                    <a
                      href="https://onceuponamat-com.setmore.com"
                      className="hover:bg-pink rounded-3xl text-white text-lg px-5 py-2 border-lightBeige border-8 bg-brown w-full block"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => trackPixelEvent("NavigateToBooking")}
                    >
                      {language === 'russian' ? "Записаться на занятие" : "Coming soon ♥"}
                    </a>
                  }
                />
              </div>}
            </div>

            {/* Форма */}
            <ContactForm />
          </div>
        </div>
      </section>
    </main>
  );
};
